export enum EHyperpayPaymentStatus {
  DID_RENEW = "DID_RENEW",
  SUBSCRIPTION_RENEWED = "SUBSCRIPTION_RENEWED",
  SUBSCRIPTION_PURCHASED = "SUBSCRIPTION_PURCHASED",
  SUBSCRIPTION_CANCELLED = "SUBSCRIPTION_CANCELLED",
  SUBSCRIPTION_EXPIRED = "SUBSCRIPTION_EXPIRED",
  SUBSCRIPTION_REFUNDED = "SUBSCRIPTION_REFUNDED",
  INITIAL_BUY = "INITIAL_BUY"
}
